import {atom, useAtom, useSetAtom} from "jotai";
import {modalController} from "../../store";
import {ModalBody, ModalFooter, ModalHeader} from "../../components/modal/Modal";
import {VerticalRule} from "../../components/common/Common";
import {Controller, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";

import {
  bannerCategoryOneDepthList,
  bannerCategoryTwoDepthList,
  bannerSizeList,
  createInventory,
  inventoryTypeList,
  targetingTypeList, uploadAudioFile
} from "../../services/mediamanage/InventoryAxios";
import {
  Board,
  BoardHeader,
  CalendarBox,
  CalendarIcon,
  CancelButton,
  ColSpan1,
  ColTitle,
  CustomDatePicker,
  DateContainer,
  Input,
  inputStyle,
  RowSpan,
  SubmitButton,
  SubmitContainer,
  ValidationScript
} from "../../assets/GlobalStyles";
import {
  adPreviewSize,
  calculationAllType,
  exposureIntervalType,
  inventoryType,
  mediaResistInfo,
  productTypeInfo
} from "./entity/common";
import React, {useEffect, useRef, useState} from "react";
import {ListBody, ListHead} from "../../components/layout";
import {SearchUser} from "../../components/common/SearchUser";
import Select from "react-select";
import {decimalFormat, removeStr} from "../../common/StringUtils";
import ko from "date-fns/locale/ko";
import {
  Box,
  CustomRadio,
  GuideBody,
  GuideContainer,
  GuideHeader,
  InputWiden,
  Preview,
  PreviewBody,
  PreviewSubmit,
  PreviewTab,
  ProductSet,
  ScriptSubject,
  SelectBanner,
  Textarea
} from "./styles";
import {atomWithReset, useResetAtom} from "jotai/utils";
import {Icon} from "../../components/table";
import {AudioEditor} from "../../components/common/AudioEditor";
import styled from "styled-components";

const MediaResistAtom = atomWithReset(mediaResistInfo)

function MediaInfo(props) {
  const [mediaResistState, setMediaResistState] = useAtom(MediaResistAtom)
  const [mediaCategoryOneDepthState, setMediaCategoryOneDepthState] = useState([])
  const [, setMediaCategoryTwoDepthState] = useState([])
  const [, setDeviceType] = useState('PC')
  const [, setModal] = useAtom(modalController)
  const [, setChecked] = useState({
    WEB: false,
    WEB_APP: false,
    MOBILE_WEB: false,
    MOBILE_HYBRID_APP: false,
    MOBILE_NATIVE_APP: false
  })
  const {register, controls, setValue, errors, clearErrors} = props
  /**
   * 디바이스 선택
   * @param deviceType
   */
  const handleDeviceType = (deviceType) => {
    setMediaResistState({
      ...mediaResistState,
      deviceType: deviceType,
      agentTypes: ['MOBILE_WEB']
    })
    setChecked({
      WEB: false,
      WEB_APP: false,
      MOBILE_WEB: false,
      MOBILE_HYBRID_APP: false,
      MOBILE_NATIVE_APP: false
    });
    setDeviceType(deviceType)
    setValue('deviceType', deviceType)
    setValue('agentTypes', ['MOBILE_WEB'])
    clearErrors('deviceType')
  }

  useEffect(() => {
    const initialState = {
      ...mediaResistInfo,
      deviceType: 'PC',
      agentTypes: ['MOBILE_WEB'],
    };

    setMediaResistState(initialState);

    setValue('deviceType', 'PC');
    setValue('agentTypes', ['MOBILE_WEB']);
    clearErrors('deviceType');

    bannerCategoryOneDepthList().then(response =>
        setMediaCategoryOneDepthState(response.values)
    );
  }, [setMediaResistState, setValue, clearErrors]);

  useEffect(()=>{
    if(mediaResistState.category1 !== ''){
      bannerCategoryTwoDepthList(mediaResistState.category1).then(response =>
        setMediaCategoryTwoDepthState(response.values)
      )
      //handleMediaCategoryTwoDepth('')
    }
  },[mediaResistState.category1])


  /**
   * 모달안에 선택완료 선택시
   */
  const handleMediaSearchSelected = (item) => {
    setModal({
      isShow: false,
      modalComponent: null
    })
    setMediaResistState({
      ...mediaResistState,
      siteName: item.siteName
    })
    setValue('userId', item.id)
    setValue('siteName', item.siteName);
    clearErrors('siteName')
  }

  /**
   * 지면명 입력
   * @param event
   */
  const handleInventoryName = (event) => {
    setMediaResistState({
      ...mediaResistState,
      inventoryName: event.target.value
    })
  }

  /**
   * 카테고리 1Depth 선택
   * @param category1
   */
  const handleMediaCategoryOneDepth = (category1) => {
    setMediaResistState({
      ...mediaResistState,
      category1: category1
    })
    setValue('category1', category1.value);
    clearErrors('category1')
  }

  /**
   * 카테고리 2Depth 선택
   * @param category1
   */
  //const handleMediaCategoryTwoDepth = (category2) => {
  //  setMediaResistState({
  //    ...mediaResistState,
  //    category2: category2
  //  })
  //  setValue('category2', category2.value);
  //}

  /**
   * 지면 URL 입력
   * @param event
   */
  const handleMediaUrl = (event) => {
    if(event.target.value !== ''){
      setMediaResistState({
        ...mediaResistState,
        mediaUrl: event.target.value
      })
    } else {
      setMediaResistState({
        ...mediaResistState,
        mediaUrl: 'https://'
      })
      setValue('mediaUrl','https://')
    }
  }

  /**
   * 지면 상세 설명
   * @param event
   */
  const handleDescription = (event) => {
    setMediaResistState({
      ...mediaResistState,
      description: event.target.value
    })
  }

  return (
    <>
      <RowSpan>
        <FieldLabelHead><span>매체 검색<RequiredMark>*</RequiredMark></span></FieldLabelHead>
        <ListBody>
          <Input type={'text'}
                 style={{width:'30%'}}
                 value={mediaResistState.siteName || ""}
                 placeholder={"매체 검색 버튼을 눌러주세요."}
                 readOnly={true}
                 {...register('siteName',{
                   required: "매체명을 선택해주세요."
                 })}
          />
          <SearchUser title={'검색'} btnStyle={'mediaCreate'} onSubmit={handleMediaSearchSelected}/>
          {errors.siteName && <ValidationScript>{errors.siteName?.message}</ValidationScript>}
        </ListBody>
      </RowSpan>
      <RowSpan>
        <FieldLabelHead>지면명<RequiredMark>*</RequiredMark></FieldLabelHead>
        <ListBody>
          <InputWiden type={'text'}
                      placeholder={'ex) 지면명칭_숫자_매체명_년월일'}
                      defaultValue={mediaResistState.inventoryName || ""}
                      onChange={e => handleInventoryName(e)}
                      {...register("inventoryName", {
                        required: "지면명을 입력해주세요."
                      })}
          />
          {errors.inventoryName && <ValidationScript>{errors.inventoryName?.message}</ValidationScript>}
        </ListBody>
      </RowSpan>
      <RowSpan>
        <FieldLabelHead>지면 카테고리<RequiredMark>*</RequiredMark></FieldLabelHead>
        <ListBody>
          <ColSpan1>
            <div>
              <Controller
                name="category1"
                control={controls}
                rules={{
                  required: {
                    value: mediaResistState.category1 === "",
                    message: "카테고리를 선택해주세요."
                  }
                }}
                render={({ field }) =>(
                  <Select options={mediaCategoryOneDepthState !== null && mediaCategoryOneDepthState}
                          placeholder={'카테고리 선택'}
                          {...field}
                          value={(mediaResistState.category1 !== undefined && mediaResistState.category1.value !== '') ? mediaResistState.category1 : ''}
                          onChange={handleMediaCategoryOneDepth}
                          styles={inputStyle}
                  />
                )}
              />
              {errors.category1 && <ValidationScript>{errors.category1?.message}</ValidationScript>}
            </div>
          </ColSpan1>

        </ListBody>
      </RowSpan>
      <RowSpan>
        <FieldLabelHead>디바이스<RequiredMark>*</RequiredMark></FieldLabelHead>
        <ListBody>
          <Controller name={'deviceType'}
                      control={controls}
                      rules={{
                        required: {
                          value: mediaResistState.deviceType === '',
                          message: "디바이스 유형을 선택해주세요."
                        }
                      }}
                      render={({field}) =>(
                          <>
                            <CustomRadio type={'radio'}
                                         {...field}
                                         id={'pc'}
                                         name={'deviceType'}
                                         checked={'PC' === mediaResistState.deviceType}
                                         onChange={() => handleDeviceType('PC')}
                            />
                            <label htmlFor={'pc'}>PC</label>
                            <CustomRadio type={'radio'}
                                         {...field}
                                         id={'mobile'}
                                         name={'deviceType'}
                                         onChange={() => handleDeviceType('MOBILE')}
                            />
                            <label htmlFor={'mobile'}>모바일 웹</label>
                            <CustomRadio type={'radio'}
                                         {...field}
                                         id={'responsive_web'}
                                         name={'deviceType'}
                                         onChange={() => handleDeviceType( 'RESPONSIVE_WEB')}
                            />
                            <label htmlFor={'responsive_web'}>반응형 웹</label>
                            <CustomRadio type={'radio'}
                                         {...field}
                                         id={'app'}
                                         name={'deviceType'}
                                         onChange={() => handleDeviceType('APP')}
                            />
                            <label htmlFor={'app'}>APP</label>
                          </>) }
          />

          {errors.deviceType && <ValidationScript>{errors.deviceType?.message}</ValidationScript>}
        </ListBody>
      </RowSpan>
      {/*<RowSpan>*/}
      {/*  <ListHead>에이전트</ListHead>*/}
      {/*  <ListBody>*/}
      {/*    <EventSet>*/}
      {/*      {(mediaResistState.deviceType === '' || mediaResistState.deviceType === 'PC'|| mediaResistState.deviceType === 'RESPONSIVE_WEB') &&*/}
      {/*            <Controller name={'agentChecked'}*/}
      {/*                        control={controls}*/}
      {/*                        rules={{*/}
      {/*                          required: {*/}
      {/*                            value: mediaResistState.agentTypes?.length === 0,*/}
      {/*                            message: "에이전트 유형을 선택해주세요."*/}
      {/*                          }*/}
      {/*                        }}*/}
      {/*                        render={({field}) =>*/}
      {/*                          <Checkbox {...field} label={'PC 웹'} type={'c'} id={'WEB'} isChecked={checked.WEB}*/}
      {/*                                    onChange={handleAgentType} inputRef={field.ref}/>}/>*/}
      {/*            }*/}

      {/*      {(mediaResistState.deviceType === '' || mediaResistState.deviceType === 'PC') &&*/}
      {/*            <Controller name={'agentChecked'}*/}
      {/*                        control={controls}*/}
      {/*                        rules={{*/}
      {/*                          required: {*/}
      {/*                            value: mediaResistState.agentTypes?.length === 0,*/}
      {/*                            message: "에이전트 유형을 선택해주세요."*/}
      {/*                          }*/}
      {/*                        }}*/}
      {/*                        render={({field}) =>*/}
      {/*                          <Checkbox label={'PC 어플리케이션'} type={'c'} id={'WEB_APP'} isChecked={checked.WEB_APP}*/}
      {/*                                    {...field}*/}
      {/*                                    onChange={handleAgentType}/>}/>*/}
      {/*      }*/}

      {/*      {(mediaResistState.deviceType === '' || mediaResistState.deviceType === 'MOBILE' || mediaResistState.deviceType === 'RESPONSIVE_WEB') &&*/}
      {/*          <Controller name={'agentChecked'}*/}
      {/*                  control={controls}*/}
      {/*                      rules={{*/}
      {/*                        required: {*/}
      {/*                          value: mediaResistState.agentTypes?.length === 0,*/}
      {/*                          message: "에이전트 유형을 선택해주세요."*/}
      {/*                        }*/}
      {/*                      }}*/}
      {/*                  render={({field}) =>*/}
      {/*                    <Checkbox label={'모바일 웹'} type={'c'} id={'MOBILE_WEB'} isChecked={checked.MOBILE_WEB}*/}
      {/*                              {...field}*/}
      {/*                              onChange={handleAgentType}/>}/>*/}
      {/*      }*/}

      {/*      {(mediaResistState.deviceType === '' || mediaResistState.deviceType !== 'PC') &&*/}
      {/*          <Controller name={'agentChecked'}*/}
      {/*                      control={controls}*/}
      {/*                      rules={{*/}
      {/*                        required: {*/}
      {/*                          value: mediaResistState.agentTypes?.length === 0,*/}
      {/*                          message: "에이전트 유형을 선택해주세요."*/}
      {/*                        }*/}
      {/*                      }}*/}
      {/*                      render={({field}) =>*/}
      {/*                          <Checkbox label={'하이브리드 APP'} type={'c'}*/}
      {/*                                    {...field}*/}
      {/*                                    id={'MOBILE_HYBRID_APP'}*/}
      {/*                                    isChecked={checked.MOBILE_HYBRID_APP}*/}
      {/*                                    onChange={handleAgentType}/>}/>*/}
      {/*      }*/}

      {/*      {(mediaResistState.deviceType === '' || mediaResistState.deviceType === 'APP') &&*/}
      {/*          <Controller name={'agentChecked'}*/}
      {/*                      control={controls}*/}
      {/*                      rules={{*/}
      {/*                        required: {*/}
      {/*                          value: mediaResistState.agentTypes?.length === 0,*/}
      {/*                          message: "에이전트 유형을 선택해주세요."*/}
      {/*                        }*/}
      {/*                      }}*/}
      {/*                      render={({field}) =>*/}
      {/*                          <Checkbox label={'네이티브 APP'} type={'c'}*/}
      {/*                                    {...field}*/}
      {/*                                    id={'MOBILE_NATIVE_APP'}*/}
      {/*                                    isChecked={checked.MOBILE_NATIVE_APP}*/}
      {/*                                    onChange={handleAgentType}/>}/>*/}
      {/*      }*/}

      {/*    </EventSet>*/}
      {/*    {errors.agentChecked && <ValidationScript>{errors.agentChecked?.message}</ValidationScript>}*/}
      {/*  </ListBody>*/}
      {/*</RowSpan>*/}
      <RowSpan>
        <FieldLabelHead>지면 URL<RequiredMark>*</RequiredMark><p>APP 마켓 URL</p></FieldLabelHead>
        <ListBody>
          <InputWiden type={'text'}
                      placeholder={'https://'}
                      onFocus={(e)=> handleMediaUrl(e)}
                      defaultValue={mediaResistState.mediaUrl || ''}
                      {...register("mediaUrl", {
                        required: "사이트 URL 입력해주세요.",
                        pattern:{
                          value:  /(http(s)?:\/\/)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}/gi,
                          message: "http(s)://가 포함된 url 주소를 확인해주세요."
                        },
                        onChange:(e) => handleMediaUrl(e)
                      })}
          />
          {errors.mediaUrl && <ValidationScript>{errors.mediaUrl?.message}</ValidationScript>}
        </ListBody>
      </RowSpan>
      <RowSpan>
        <FieldLabelHead $optional>지면 상세 설명<p>선택 입력</p></FieldLabelHead>
        <ListBody>
          <Textarea rows={5}
                    maxLength={1000}
                    placeholder={''}
                    value={mediaResistState.description || ''}
                    onChange={(e) => handleDescription(e)}
                    onBlur={()=>{
                      setValue('description', mediaResistState.description)
                    }}
          />
          {errors.description && <ValidationScript>{errors.description?.message}</ValidationScript>}
        </ListBody>
      </RowSpan>
    </>
  )
}

const bannerSize = atom([])

function PreviewBanner() {
  const [size] = useAtom(bannerSize)
  return (
    <div style={size?.length !== 0 ? {width: parseInt(size[0]), height: parseInt(size[1])} : null}></div>
  )
}
function AdProductInfo(props) {
  const [mediaResistState, setMediaResistState] = useAtom(MediaResistAtom)
  const [adPreviewSizeInfo, setAdPreviewSizeInfo] = useState(adPreviewSize)
  const [selectBannerSizeName, setSelectBannerSizeName] = useState('')
  const setPreviewBannerSize = useSetAtom(bannerSize)
  const setModal = useSetAtom(modalController)
  const [inventoryTypeState, setInventoryTypeState] = useState(inventoryType)
  const [, setTargetingTypeState] = useState(null)
  const [exposureInterval] = useState(exposureIntervalType)

  const {controls, errors, setValue, setError} = props;

  useEffect(() => {
    bannerSizeList().then(response => {
      if (response) {
        setAdPreviewSizeInfo(response.values);
      }
    });

    inventoryTypeList().then(response => {
      if (response) {
        setInventoryTypeState(response.values);
      }
    });

    targetingTypeList().then(response => {
      const values = response.values;

      if (values) {
        setTargetingTypeState(values);

        setMediaResistState(prev => ({
          ...prev,
          allowTargetings: values,
        }));

        setValue(
            "allowTargetings",
            values.map(targetingState => ({
              targetingType: targetingState.value,
              exposureWeight: 100,
            }))
        );
      }
    });

    setValue('productType', mediaResistState.productType);
  }, [
    mediaResistState.productType,
    setMediaResistState,
    setValue,
  ]);

  /**
   * 광고유형가이드 선택 (임시 닫음)
   */
  // const handleModalAdTypeGuide = () => {
  //   setModal({
  //     isShow: true,
  //     width: 1320,
  //     modalComponent: () => componentModalAdTypeGuide()
  //   })
  // }

  // const componentModalAdTypeGuide = () => {
  //   return (
  //     <div>
  //       <ModalHeader title={'광고 유형 가이드'}/>
  //       <ModalBody>
  //         <GuideContainer>
  //           <GuideHeader>배너 광고란?</GuideHeader>
  //           <GuideSubject>배너 광고 안내 내용</GuideSubject>
  //           <GuideBody>
  //             <div>
  //               <AdSample/>
  //               <p>광고 예시</p>
  //             </div>
  //           </GuideBody>
  //         </GuideContainer>
  //         <VerticalRule style={{margin: '20px 0'}}/>
  //         <GuideContainer>
  //           <GuideHeader>아이커버 광고란?</GuideHeader>
  //           <GuideSubject>아이커버 안내 내용</GuideSubject>
  //           <GuideBody>
  //             <div>
  //               <AdSample/>
  //               <p>광고 예시</p>
  //             </div>
  //           </GuideBody>
  //         </GuideContainer>
  //       </ModalBody>
  //     </div>
  //   )
  // }

  /**
   * 모달 지면 선택 핸들링
   * @param item
   */
  const handleSelectPreviewBanner = (item) => {
    setPreviewBannerSize(item.value?.replace('IMG', '').split('_'))
    setSelectBannerSizeName(item.value)
    handleModalPreview(item.value)
  }

  /**
   * 지면 미리보기 모달
   */
  const handleModalPreview = (value) => {
    setModal({
      isShow: true,
      width: 1320,
      modalComponent: () => componentModalPreview(value !== undefined ? value : selectBannerSizeName)
    })
  }

  const componentModalPreview = (target) => {
    return (
      <div>
        <ModalHeader title={'지면 미리보기'}/>
        <ModalBody>
          <PreviewTab>
            {adPreviewSizeInfo !== null && adPreviewSizeInfo.map((item, key) => {
              return (
                <div key={key} id={item.value}
                     onClick={() => handleSelectPreviewBanner(item)}
                     style={target === item.value ? {border: "1px solid var(--color-main)", color: "var(--color-main)"} : null}
                >{item.label.replace('w','').split('(')[0]}</div>
              )
            })}
          </PreviewTab>
          <PreviewBody>
            <PreviewBanner/>
          </PreviewBody>
        </ModalBody>
        <ModalFooter>
          <PreviewSubmit onClick={() => setModal({isShow: false, modalComponent: null})}>확인</PreviewSubmit>
        </ModalFooter>
      </div>
    )
  }

  /**
   * 지면사이즈 선택 핸들링
   * @param event
   */
  const handleSelectBanner = (event) => {

    setMediaResistState({
      ...mediaResistState,
      bannerSize: event.target.dataset.value
    })
    if (event.target.dataset.name === undefined) {
      setSelectBannerSizeName(event.target.parentElement.dataset.value)
      setValue('bannerSize', event.target.parentElement.dataset.value)
      adPreviewSizeInfo.forEach((item) => {
        if (item.value === event.target.parentElement.dataset.value) {
          setPreviewBannerSize(item.value.replace('IMG', '').split('_'))
        }
        return null
      })
    } else {
      setSelectBannerSizeName(event.target.dataset.value)
      adPreviewSizeInfo.forEach((item) => {
        if (item.value === event.target.parentElement.dataset.value) {
          setPreviewBannerSize(item.value.replace('IMG', '').split('_'));
        }
      });
      setValue('bannerSize', event.target.dataset.value)
    }
    setError('bannerSize', '')
  }

  const selectBannerHover = {
    border: '1px solid var(--color-main)'
  }

  /**
   * 광고 상품 선택
   * @param event
   */
  const handleProductType = (event) => {

    setMediaResistState({
      ...mediaResistState,
      productType: event.target.id,
      inventoryType: '',
    })
    setValue('productType',event.target.id);
  }

  /**
   * 지면 유형 선택
   * @param inventoryType
   */
  const handleInventoryType = (inventoryType) => {
    setMediaResistState({
      ...mediaResistState,
      inventoryType: inventoryType.value
    })
    setValue('inventoryType', inventoryType.value)
    setError('inventoryType', '')
  }
  /**
   * 지면 노출 간격 선택(팝언더만 해당)
   * @param exposureInterval
   */
  const handleExposureInterval = (exposureInterval) => {
    setMediaResistState({
      ...mediaResistState,
      exposureInterval: exposureInterval
    })
    setValue('exposureInterval', exposureInterval.value)
    setError('exposureInterval', '')
  }


  return (
    <>
      <RowSpan>
        <FieldLabelHead>광고 상품<RequiredMark>*</RequiredMark></FieldLabelHead>
        <ListBody>
          <ProductSet>
            {productTypeInfo.map((data,index) => {
              return index !== 0 &&
                (<div key={index}>
                  <input type={'radio'} id={data.value} disabled={index !== 3} checked={mediaResistState.productType === data.value ? true : false} name={'product'} onChange={handleProductType}/>
                  <label htmlFor={data.value}>{data.label}</label>
                </div>)
            })}
          </ProductSet>
          {/*임시 닫음 <GuideButton type={'button'} onClick={handleModalAdTypeGuide}>광고 유형 가이드</GuideButton>*/}
        </ListBody>
      </RowSpan>
      {/*<RowSpan>*/}
      {/*  <ListHead>타겟팅 설정</ListHead>*/}
      {/*  <ListBody>*/}
      {/*    <EventSet>*/}
      {/*      <Controller name={'targetingChecked'}*/}
      {/*                  control={controls}*/}
      {/*                  rules={{*/}
      {/*                    required: {*/}
      {/*                      value: mediaResistState.allowTargetings?.length === 0,*/}
      {/*                      message: "타겟팅을 설정을 해주세요."*/}
      {/*                    }*/}
      {/*                  }}*/}
      {/*                  render={({field}) =>*/}
      {/*                    <Checkbox {...field} label={'전체'} type={'c'} id={'ALL'} isChecked={targetingTypeState != null && (mediaResistState.allowTargetings?.length === targetingTypeState?.length)}*/}
      {/*                              onChange={handleChangeSelectAll} inputRef={field.ref}/>}*/}
      {/*      />*/}
      {/*      {*/}
      {/*        targetingTypeState != null && targetingTypeState.map((data, key)=>{*/}
      {/*          return <Controller name={'targetingChecked'}*/}
      {/*                             control={controls}*/}
      {/*                             key={key}*/}
      {/*                             render={({field}) =>*/}
      {/*                               <Checkbox label={data.label} type={'c'} id={data.value} isChecked={mediaResistState.allowTargetings.some(event => event.value === data.value)}*/}
      {/*                                         onChange={handleChangeChecked} inputRef={field.ref}/>}*/}
      {/*          />*/}
      {/*        })*/}
      {/*      }*/}
      {/*    </EventSet>*/}
      {/*    {errors.targetingChecked && <ValidationScript>{errors.targetingChecked?.message}</ValidationScript>}*/}
      {/*  </ListBody>*/}
      {/*</RowSpan>*/}
      <RowSpan>
        <FieldLabelHead>지면 유형<RequiredMark>*</RequiredMark></FieldLabelHead>
        <ListBody>
          <ColSpan1>
            <Controller
              name="inventoryType"
              control={controls}
              rules={{
                required: {
                  value: mediaResistState.inventoryType === '',
                  message: "지면 유형을 선택해 주세요."
                }
              }}
              render={({ field }) =>(
                <Select options={(mediaResistState.productType !== undefined && mediaResistState.productType !== '') ? inventoryTypeState.filter(value => (value.value.indexOf(mediaResistState.productType)>-1)) : inventoryTypeState}
                        placeholder={'지면 유형을 선택해 주세요.'}
                        value={(mediaResistState.inventoryType !== undefined && mediaResistState.inventoryType !== '') ? inventoryTypeState.find(obj => obj.value === mediaResistState.inventoryType) : ''}
                        onChange={handleInventoryType}
                        isSearchable={false}
                        styles={inputStyle}
                />
              )}
            />
          </ColSpan1>
          {errors.inventoryType && <ValidationScript>{errors.inventoryType?.message}</ValidationScript>}
        </ListBody>
      </RowSpan>
      {mediaResistState.productType === 'BANNER' &&
        <RowSpan>
          <FieldLabelHead>지면 사이즈</FieldLabelHead>
          <ListBody>
            <Controller
              name="bannerSize"
              control={controls}
              rules={{
                required: {
                  value: mediaResistState.bannerSize === '',
                  message: "지면 사이즈를 선택해주세요."
                }
              }}
              render={({ field }) =>(
                <SelectBanner>
                  {adPreviewSizeInfo !== null && adPreviewSizeInfo.map((item, key) => {
                    return (
                      <div key={key} data-name={item.label} onClick={handleSelectBanner}
                           style={selectBannerSizeName === item.value ? selectBannerHover : null} data-value={item.value}>
                        <Box style={{
                          width: `${item.value?.replace('IMG', '').split('_')[0] / 6}px`,
                          height: `${item.value?.replace('IMG', '').split('_')[1] / 6}px`
                        }}/>
                        <div>{item.label.replace('w','').split('(')[0]}</div>
                        {selectBannerSizeName === item.value &&
                          <Preview onClick={() => handleModalPreview()}>지면미리보기</Preview>
                        }
                      </div>
                    )
                  })}
                </SelectBanner>
              )}
            />
            {errors.bannerSize && <ValidationScript>{errors.bannerSize?.message}</ValidationScript>}
          </ListBody>
        </RowSpan>
      }
      {mediaResistState.productType === 'POP_UNDER' &&
        <RowSpan>
          <FieldLabelHead>노출 간격</FieldLabelHead>
          <ListBody>
            <ColSpan1>
              <Controller
                name="exposureInterval"
                control={controls}
                rules={{
                  required: {
                    value: mediaResistState.exposureInterval === '',
                    message: "노출 간격을 선택해주세요."
                  }
                }}
                render={({ field }) =>(
                  <Select options={exposureInterval}
                          placeholder={'선택하세요'}
                          value={(mediaResistState.exposureInterval !== undefined && mediaResistState.exposureInterval !== '') ? mediaResistState.exposureInterval : '0'}
                          onChange={handleExposureInterval}
                          isSearchable={false}
                          styles={inputStyle}
                  />
                )}
              />
            </ColSpan1>
            {errors.exposureInterval && <ValidationScript>{errors.exposureInterval?.message}</ValidationScript>}
          </ListBody>
        </RowSpan>
      }
    </>
  )
}

function MediaAccount(props) {
  const [mediaResistState, setMediaResistState] = useAtom(MediaResistAtom)
  const [calculationAllTypeState] = useState(calculationAllType)
  const {controls, setValue,setError, errors} = props

  /**
   * 정산방식 선택날짜
   * @param date
   */
  const handleContractDate = (date) => {
    //if(isOverToday(new Date(), new Date(date))) {
      setMediaResistState({
        ...mediaResistState,
        feeCalculation: {
          ...mediaResistState.feeCalculation,
          contractStartDate: date
        }
      })
      setValue('feeCalculation.contractStartDate', date)
    //}
  }
  /**
   * 정산방식 선택
   * @param calculationType
   */
  const handleCalculationType = (calculationType) => {
    setMediaResistState({
      ...mediaResistState,
      feeCalculation: {
        ...mediaResistState.feeCalculation,
        calculationType: calculationType.value
      }
    })
    setValue('feeCalculation.calculationType',  calculationType.value)
    setError('calculationType','')
  }
  /**
   * 정산방식 값 입력
   * @param calculationValue
   */
  const handleCalculationValue = (value) => {
    let num = removeStr(value)
    let numberNum = Number(num)
    setMediaResistState({
      ...mediaResistState,
      feeCalculation: {
        ...mediaResistState.feeCalculation,
        calculationValue: numberNum
      }
    })
    setValue('feeCalculation.calculationValue', numberNum)
    setError('calculationValue','')
  }
  /**
   * 비고 입력
   * @param event
   */
  const handleCalculationEtc = (event) => {
    setMediaResistState({
      ...mediaResistState,
      feeCalculation: {
        ...mediaResistState.feeCalculation,
        calculationEtc: event.target.value
      }
    })
    setValue('feeCalculation.calculationEtc', event.target.value)
  }

  function handlePlaceholder (type) {
    switch (type){
      case 'CPM' : case 'CPC' : return '단위별 금액을 입력해주세요.';
      case 'RS' : return '정산 비율을 입력해주세요.';
      case 'GT' : return '개런티 비용을 입력해주세요.';
      default : return '단위별 금액을 입력해주세요.';
    }
  }

  return (
    <>
      <RowSpan style={{width: '100%', alignItems: 'center'}}>
        <ColSpan1>
          <ColTitle style={{paddingLeft: 0}}><span>계약 날짜<RequiredMark>*</RequiredMark></span></ColTitle>
          <div style={{position: "relative"}}>
            <DateContainer>
              <CalendarBox>
                <CalendarIcon/>
              </CalendarBox>
              <CustomDatePicker
                showIcon={false}
                selected={mediaResistState.feeCalculation.contractStartDate}
                onChange={(date) => handleContractDate(date)}
                locale={ko}
                //minDate={new Date()}
                dateFormat="yyyy-MM-dd"
                isClearable={false}
              />
            </DateContainer>
          </div>
        </ColSpan1>
        <ColSpan1>
          <ColTitle><span>정산 유형<RequiredMark>*</RequiredMark></span></ColTitle>
          <div>
            <Controller
              name="calculationType"
              control={controls}
              rules={{
                required: {
                  value: mediaResistState.feeCalculation.calculationType === '',
                  message: "정산 유형을 선택해주세요."
                }
              }}
              render={({ field }) =>(
                <Select options={calculationAllTypeState.filter((data,index) => index !== 0)}
                        placeholder={'선택하세요'}
                        styles={inputStyle}
                        isSearchable={false}
                        value={(mediaResistState.feeCalculation.calculationType !== undefined && mediaResistState.feeCalculation.calculationType !== '') ? calculationAllTypeState.find(obj => obj.value === mediaResistState.feeCalculation.calculationType) : ''}
                        onChange={(e)=>handleCalculationType(e)}
                />
              )}
            />
            {errors.calculationType && <ValidationScript>{errors.calculationType?.message}</ValidationScript>}
          </div>

        </ColSpan1>
        <ColSpan1>
          <ColTitle><span>정산 금액<RequiredMark>*</RequiredMark></span></ColTitle>
          <div>
            <Controller
              name="calculationValue"
              control={controls}
              rules={{
                required: {
                  value: mediaResistState.feeCalculation.calculationValue === 0,
                  message: handlePlaceholder(mediaResistState.feeCalculation.calculationType)
                }
              }}
              render={({ field }) =>(
                <Input type={'text'}
                       placeholder={handlePlaceholder(mediaResistState.feeCalculation.calculationType)}
                       maxLength={12}
                       style={{color:'var(--color-main)'}}
                       value={mediaResistState.feeCalculation.calculationValue !== 0 ? decimalFormat(mediaResistState.feeCalculation.calculationValue) : ''}
                       onChange={(e)=>handleCalculationValue(e.target.value)}
                /> )}
            />
            {errors.calculationValue && <ValidationScript>{errors.calculationValue?.message}</ValidationScript>}
          </div>
        </ColSpan1>
        <ColSpan1>
          <ColTitle style={{textAlign: 'right'}}><span>비고</span></ColTitle>
          <Input type={'text'}
                 placeholder={'비고'}
                 value={mediaResistState.feeCalculation.calculationEtc}
                 onChange={handleCalculationEtc}
          />
        </ColSpan1>
      </RowSpan>
    </>
  )
}

function AddInfo(props) {
  const [mediaResistState, setMediaResistState] = useAtom(MediaResistAtom);
  const [showNonExposureConfigValue, setShowNonExposureConfigValue] = useState(false);
  const {file, setFile, setValue} = props
  useEffect(() => {
    setValue('nonExposureConfigType', mediaResistState.nonExposureConfigType);
  }, [mediaResistState.nonExposureConfigType, setValue]);
  /**
   * 미송출시 타입 선택
   * @param nonExposureConfigType
   */
  const handleNonExposureConfigType = (nonExposureConfigType) => {
    if (nonExposureConfigType === "DEFAULT_BANNER_IMAGE" || nonExposureConfigType === 'NONE') {
      setShowNonExposureConfigValue(false)
    } else {
      setShowNonExposureConfigValue(true)
    }
    setMediaResistState({
      ...mediaResistState,
      nonExposureConfigType: nonExposureConfigType
    })
    setValue('nonExposureConfigType', nonExposureConfigType)
  }

  /**
   * 미송출시 데이터 입력
   * @param event
   */
  const handleNonExposureConfigValue = (event) => {
    setMediaResistState({
      ...mediaResistState,
      nonExposureConfigValue: event.target.value
    })
    setValue('nonExposureConfigValue', event.target.value)
  }

  function handlePlaceholder(type) {
    switch (type) {
      case 'JSON':
      case 'URL':
        return '설정할 URL 정보를 입력해주세요.';
      case 'SCRIPT':
        return '설정할 SCRIPT 정보를 입력해주세요.';
      default:
        return '미송출시 대체 광고 정보를 입력하세요.';
    }
  }

  return (
    <>
      <RowSpan>
        <FieldLabelHead $optional>광고 미송출 대체 설정<p>선택 입력</p></FieldLabelHead>
        <ListBody>
          <>
            <input type={'radio'}
                   id={'none'}
                   name={'substitute'}
                   checked={mediaResistState.nonExposureConfigType === 'NONE'}
                   onChange={() => handleNonExposureConfigType('NONE')}
            />
            <label htmlFor={'none'}>없음</label>
          </>
          {mediaResistState.productType === 'BANNER' &&
            <>
              <input type={'radio'}
                     id={'defaultImage'}
                     name={'substitute'}
                     checked={mediaResistState.nonExposureConfigType === 'DEFAULT_BANNER_IMAGE'}
                     onChange={() => handleNonExposureConfigType('DEFAULT_BANNER_IMAGE')}
              />
              <label htmlFor={'defaultImage'}>대체 이미지</label>

              <input type={'radio'}
                     id={'jsonData'}
                     name={'substitute'}
                     checked={mediaResistState.nonExposureConfigType === 'JSON'}
                     onChange={() => handleNonExposureConfigType('JSON')}
              />
              <label htmlFor={'jsonData'}>JSON DATA</label>
            </>
          }
          <input type={'radio'}
                 id={'URL'}
                 name={'substitute'}
                 checked={mediaResistState.nonExposureConfigType === 'URL'}
                 onChange={() => handleNonExposureConfigType('URL')}
          />
          <label htmlFor={'URL'}>URL</label>

          <input type={'radio'}
                 id={'script'}
                 name={'substitute'}
                 checked={mediaResistState.nonExposureConfigType === 'SCRIPT'}
                 onChange={() => handleNonExposureConfigType('SCRIPT')}
          />
          <label htmlFor={'script'}>script</label>
          <input type={'radio'}
                 id={'file'}
                 name={'substitute'}
                 checked={mediaResistState.nonExposureConfigType === 'FILE'}
                 onChange={() => handleNonExposureConfigType('FILE')}
          />
          <label htmlFor={'file'}>파일</label>
        </ListBody>
      </RowSpan>
      <RowSpan>
        <ListHead></ListHead>
        <ListBody>
          {showNonExposureConfigValue ?
              (mediaResistState.nonExposureConfigType === 'FILE' ?
              <AudioEditor file={file} setFile={setFile} filePath={mediaResistState.nonExposureConfigValue}/>
              :
              <Textarea rows={5}
                      placeholder={handlePlaceholder(mediaResistState.nonExposureConfigType)}
                      value={mediaResistState.nonExposureConfigValue}
                      onChange={(e) => handleNonExposureConfigValue(e)}
            />):''
          }

        </ListBody>
      </RowSpan>

    </>
  )
}
export default function Media() {
  const [,setModal] = useAtom(modalController)
  const [mediaResistState] = useAtom(MediaResistAtom)
  const resetMediaResistAtom = useResetAtom(MediaResistAtom);
  const [file, setFile] = useState(null);
  const sectionRefs = useRef([]);
  useEffect(() => {
    return () => {
      resetMediaResistAtom();
      setModal({isShow: false});
    };
  }, [resetMediaResistAtom, setModal]);

  const handleModalRegistration = (inventoryId) => {
    setModal({
      isShow: true,
      width: 1320,
      modalComponent: () => {
        return (
          <div>
            <ModalHeader title={'지면 스크립트 발급 안내'} closeBtn={false} />
            <ModalBody>
              <ScriptSubject>
                <div>지면 등록이 완료되었습니다.<br/>
                  하단 발급된 광고 API를
                  <a
                      href="https://www.notion.so/API-2afbe20d845e8002a124c20d307295da?source=copy_link"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{fontWeight: "bold", fontSize: '17px', marginLeft: '10px', color: 'rgb(30, 58, 138)'}}
                  >
                    광고 송출 가이드
                  </a>를 참고하여 표출할 광고 콘텐츠 영역에 삽입해주세요.
                </div>
                <div>※ 발급된 스크립트 정보는 지면 관리에서 확인 가능합니다.</div>
              </ScriptSubject>
              <GuideContainer>
                <GuideHeader>광고 API(JSON) <Icon icon={'copyCode'} value={'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+inventoryId + '&output=json'}/></GuideHeader>
                <GuideBody>
                  <pre>{'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+inventoryId + '&output=json'}</pre>
                </GuideBody>
                <VerticalRule style={{margin: "20px 0"}}/>
                <GuideHeader>광고 API(XML) <Icon icon={'copyCode'} value={'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+inventoryId + '&output=xml'}/></GuideHeader>
                <GuideBody>
                  <pre>{'https://dsp.oaple.co.kr/audio/ad?mediaScriptNo='+inventoryId + '&output=xml'}</pre>
                </GuideBody>
              </GuideContainer>
            </ModalBody>
            <ModalFooter>
              <PreviewSubmit onClick={() => {
                setModal({isShow: false})
                navigate('/board/mediaList')
              }
              }>확인</PreviewSubmit>
            </ModalFooter>
          </div>
        )
      }
    })
  }
  const { register, handleSubmit, control, setValue, setError, formState: { errors }, clearErrors } = useForm();
  const onError = (error) => console.log(error)
  const navigate = useNavigate();
  const scrollToSection = index => {
    sectionRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    })
  }
  const sectionCompleted = [
    Boolean(
        mediaResistState.siteName
        && mediaResistState.inventoryName
        && mediaResistState.category1
        && mediaResistState.deviceType
        && mediaResistState.mediaUrl
    ),
    Boolean(
        mediaResistState.productType
        && mediaResistState.inventoryType
        && (mediaResistState.productType !== "BANNER" || mediaResistState.bannerSize)
        && (mediaResistState.productType !== "POP_UNDER" || mediaResistState.exposureInterval)
    ),
    Boolean(
        mediaResistState.feeCalculation?.contractStartDate
        && mediaResistState.feeCalculation?.calculationType
        && Number(mediaResistState.feeCalculation?.calculationValue) > 0
    ),
  ]
  const pickVideo = async () => {
    let returnVal = null;
    if (file.length !== 0) {
      await uploadAudioFile(file).then(response => {
        const { uploadedFile, path, duration } = response;
        if (uploadedFile) {
          toast.success('업로드에 성공 했습니다.');
          returnVal = {path: path, duration: duration};
        } else {
          toast.warning('업로드에 실패 했습니다.');
        }
      })
    }
    return returnVal;
  }
  const onSubmit = (data) => {
    if(data.feeCalculation.contractStartDate === undefined) data.feeCalculation.contractStartDate = new Date();

    if(data.nonExposureConfigType === "FILE") {
      if (file == null || file.size <= 0) {
        toast.warning('파일을 업로드해주세요')
      } else {
        console.log(file)
        pickVideo().then((response) => {
              if (response !== null) {
                createInventory({
                  ...data,
                  nonExposureConfigValue: response?.path,
                  nonExposureConfigDuration: response?.duration
                }).then((response) => {
                  if (response !== null) {
                    alert('지면이 생성되었습니다.')
                    handleModalRegistration(response)
                  }
                })
              }
            }
        );
      }
    } else {
      createInventory(data).then((response) => {
        if (response !== null) {
          alert('지면이 생성되었습니다.')
          handleModalRegistration(response)
        }
      })
    }
  }
  return (
    <main>
      <MediaCreatePage>
        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <MediaFormLayout>
            <MediaFormBoard>
              <MediaCreateHeader>
                <div>
                  <h1>지면 등록</h1>
                  <p>광고가 노출될 지면과 상품·정산 정보를 입력해 주세요.</p>
                </div>
                <RequiredGuide><span>*</span> 필수 입력 항목</RequiredGuide>
              </MediaCreateHeader>
              <MediaFormSurface>
                <Board ref={element => { sectionRefs.current[0] = element }}>
                  <BoardHeader>지면 정보</BoardHeader>
                  <MediaInfo register={register} controls={control} setValue={setValue}  setError={setError} clearErrors={clearErrors} errors={errors}/>
                </Board>
                <Board ref={element => { sectionRefs.current[1] = element }}>
                  <BoardHeader>광고 상품 정보</BoardHeader>
                  <AdProductInfo register={register} controls={control} setValue={setValue} setError={setError} errors={errors}/>
                </Board>
                <Board ref={element => { sectionRefs.current[2] = element }}>
                  <BoardHeader>매체 정산 정보</BoardHeader>
                  <MediaAccount register={register} controls={control} setValue={setValue} setError={setError} errors={errors}/>
                </Board>
                <Board ref={element => { sectionRefs.current[3] = element }}>
                  <BoardHeader>추가 정보 입력(선택)</BoardHeader>
                  <AddInfo register={register} setValue={setValue} errors={errors} file={file} setFile={setFile}/>
                </Board>
              </MediaFormSurface>
            </MediaFormBoard>
            <MediaFormSidebar>
              <SidebarTitle>지면 등록 정보</SidebarTitle>
              <SidebarGuide>필수 항목 3단계를 순서대로 입력해 주세요.</SidebarGuide>
              <SetupStepList>
                {[
                  "지면 기본 정보",
                  "광고 상품 설정",
                  "매체 정산 정보",
                ].map((label, index) => (
                    <SetupStep
                        key={label}
                        type="button"
                        $completed={sectionCompleted[index]}
                        onClick={() => scrollToSection(index)}
                    >
                      <b>{sectionCompleted[index] ? "✓" : index + 1}</b>
                      <span>{label}</span>
                      {sectionCompleted[index] && <CompleteLabel>설정 완료</CompleteLabel>}
                    </SetupStep>
                ))}
              </SetupStepList>
              <SubmitContainer>
                <CancelButton type={'button'} onClick={() => navigate('/board/mediaList')}>취소</CancelButton>
                <SubmitButton type={'submit'}>지면 등록</SubmitButton>
              </SubmitContainer>
            </MediaFormSidebar>
          </MediaFormLayout>
        <ToastContainer position="top-center"
                        autoClose={1500}
                        hideProgressBar
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        limit={1}
                        style={{zIndex: 9999999}}/>
        </form>
      </MediaCreatePage>
    </main>
  )
}

const FieldLabelHead = styled(ListHead)`
  position: relative;
  display: flex;
  width: 180px;
  min-width: 180px;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 3px;
  padding-left: 0;
  color: rgb(68, 68, 68);
  font-size: var(--font-size-16);
  font-weight: 600;
  line-height: 1.4;

  &::before {
    display: none;
  }

  p {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    color: #929ba5;
    font-size: var(--font-size-10);
    font-weight: 500;
    white-space: nowrap;
  }

  @media (max-width: 820px) {
    width: 100%;
    min-width: 0;
  }
`;

const RequiredMark = styled.sup`
  position: relative;
  top: -3px;
  display: inline-block;
  margin-left: 1px;
  color: var(--color-danger);
  font-size: var(--font-size-13);
  font-weight: 800;
  line-height: 1;
  vertical-align: top;
`;

const MediaCreatePage = styled.div`
  width: 100%;
  padding: 4px 0 32px;

  ${Board} {
    width: 100%;
    min-width: 0;
    scroll-margin-top: 18px;
    margin-bottom: 14px;
    padding: 0 24px 22px;
    overflow: visible;
    border: 1px solid #e4e9ef;
    border-radius: 10px;
    box-shadow: 0 5px 18px rgba(31, 41, 55, .045);
  }

  ${BoardHeader} {
    min-height: 58px;
    justify-content: flex-start;
    padding: 0;
    border-bottom: 1px solid var(--color-divider);
    color: #2f3945;
    font-size: var(--font-size-15);
    font-weight: 800;

    &::before {
      width: 4px;
      height: 16px;
      margin-right: 9px;
      border-radius: 999px;
      background: var(--color-primary);
      content: "";
    }
  }

  ${RowSpan} {
    min-height: 70px;
    margin-top: 0;
    padding: 13px 4px;
    border-bottom: 1px solid #f0f2f5;

    &:last-child {
      border-bottom: 0;
    }
  }

  ${Input},
  ${InputWiden},
  ${Textarea},
  select {
    border-color: var(--color-border-strong);
    border-radius: 7px;
    background-color: var(--color-surface);
    color: var(--color-text);
    font-size: var(--font-size-13);

    &:focus {
      border-color: #60a5fa;
      outline: none;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, .10);
    }
  }

  ${Input},
  ${InputWiden} {
    height: 42px;
  }

  ${Textarea} {
    min-height: 92px;
    padding: 12px 14px;
    resize: vertical;
  }

  ${CustomRadio}[type='radio'] + label {
    height: 40px;
    padding: 0 15px;
    border-color: var(--color-border-strong);
    border-radius: 7px;
    color: #596572;
    font-size: var(--font-size-12);
    font-weight: 650;
    transition: border-color .15s ease, background .15s ease, color .15s ease;
  }

  ${CustomRadio}[type='radio']:checked + label {
    border-color: var(--color-primary);
    background: var(--color-primary-soft);
    color: var(--color-primary-dark);
    box-shadow: inset 0 0 0 1px var(--color-primary);
  }

  input[type='radio'] {
    margin: 0 7px 0 0;
    border: 1px solid #b8c1cc;
    border-radius: 50%;
    background: var(--color-surface);
    background-image: none !important;
    box-shadow: none;
    cursor: pointer;
  }

  input[type='radio']:checked {
    border-color: var(--color-primary);
    background: var(--color-primary);
    background-image: none !important;
    box-shadow: inset 0 0 0 4px var(--color-surface);
  }

  input[type='radio'] + label {
    color: #56616d;
    font-size: var(--font-size-12);
    cursor: pointer;
  }

  ${ProductSet} {
    min-height: 42px;
    align-items: center;
    gap: 8px;

    & > div {
      min-height: 38px;
      margin-right: 0;
      padding: 0 12px;
      border: 1px solid var(--color-border-strong);
      border-radius: 7px;
      background: var(--color-surface);
    }

    & > div:has(input:checked) {
      border-color: #60a5fa;
      background: var(--color-primary-soft);
      color: var(--color-primary-dark);
    }
  }

  [class*="-control"] {
    min-height: 42px !important;
    border-color: var(--color-border-strong) !important;
    border-radius: 8px !important;
    background: var(--color-surface) !important;
    box-shadow: none !important;
    cursor: pointer;

    &:hover {
      border-color: var(--color-primary-focus) !important;
    }

    &:focus-within {
      border-color: var(--color-primary) !important;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, .10) !important;
    }
  }

  [class*="-ValueContainer"] {
    padding: 2px 11px !important;
    color: var(--color-text);
    font-size: var(--font-size-12);
  }

  [class*="-placeholder"] {
    color: #9aa3ad !important;
    font-size: var(--font-size-12);
  }

  [class*="-indicatorSeparator"] {
    display: none;
  }

  [class*="-indicatorContainer"] {
    padding: 7px !important;
    color: #89939e !important;
  }

  [class*="-menu"] {
    z-index: 20;
    overflow: hidden;
    border: 1px solid var(--color-border-strong);
    border-radius: 8px !important;
    box-shadow: 0 10px 24px rgba(31, 41, 55, .12) !important;
    font-size: var(--font-size-12);
  }

  ${DateContainer} {
    height: 42px;
    border-color: var(--color-border-strong);
    border-radius: 8px;
    background: var(--color-surface);
    transition: border-color .15s ease, box-shadow .15s ease;

    &:focus-within {
      border-color: var(--color-primary);
      box-shadow: 0 0 0 3px rgba(59, 130, 246, .10);
    }

    ${CustomDatePicker} {
      height: 40px;
      border: 0;
      background: transparent;
      color: var(--color-text);
      font-size: var(--font-size-12);
      outline: none;
    }
  }

  ${CalendarBox} {
    display: inline-flex;
    width: 40px;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    border-right: 1px solid var(--color-divider);
    background: #f8fafc;
    color: #64748b;
  }

  .react-datepicker {
    overflow: hidden;
    border: 1px solid var(--color-border-strong);
    border-radius: 10px;
    box-shadow: 0 12px 30px rgba(31, 41, 55, .14);
    font-family: inherit;
  }

  .react-datepicker__header {
    border-bottom-color: var(--color-divider);
    background: #f8fafc;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    background: var(--color-primary);
    color: var(--color-surface);
  }

  .react-datepicker__day:hover {
    background: var(--color-primary-muted);
    color: var(--color-main);
  }

  ${ValidationScript} {
    color: var(--color-danger);
    font-size: var(--font-size-11) !important;
  }

  ${ColTitle} {
    color: rgb(68, 68, 68);
    font-size: var(--font-size-16);
    font-weight: 600;

    span {
      display: inline-block;
      padding-left: 0;
      border-left: 0;
      line-height: 14px;
    }
  }

  ${SubmitContainer} {
    position: sticky;
    bottom: 0;
    z-index: 5;
    justify-content: flex-end;
    margin-top: 16px;
    padding: 12px 16px;
    border: 1px solid #e4e9ef;
    border-radius: 10px;
    background: rgba(255, 255, 255, .94);
    box-shadow: 0 -5px 20px rgba(31, 41, 55, .06);
    backdrop-filter: blur(8px);

    button {
      width: 112px;
      height: 42px;
      margin: 0 0 0 8px;
      border-radius: 7px;
      font-size: var(--font-size-13);
      font-weight: 750;
    }
  }

  ${CancelButton} {
    border-color: #d8dfe6;
    background: var(--color-surface);
    color: #65717d;
  }

  ${SubmitButton} {
    border: 1px solid var(--color-primary);
    background: var(--color-primary);
    box-shadow: 0 5px 14px rgba(59, 130, 246, .2);
    color: var(--color-surface);

    &:hover {
      background: var(--color-primary-strong);
    }
  }

  @media (max-width: 820px) {
    ${Board} {
      padding: 0 16px 16px;
    }

    ${RowSpan} {
      align-items: stretch;
      flex-direction: column;
      gap: 8px;
    }

    ${ColSpan1} {
      width: 100%;
      flex-wrap: wrap;
    }

    ${ProductSet} {
      flex-wrap: wrap;
      gap: 6px;
    }
  }

  @media (max-width: 520px) {
    ${SubmitContainer} {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));

      button {
        width: 100%;
        margin: 0;
      }
    }
  }
`;

const MediaCreateHeader = styled.div`
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 30px;
  border-bottom: 1px solid #e6e9ed;
  background: linear-gradient(135deg, var(--color-surface) 0%, #f6faff 100%);

  h1 {
    margin: 0;
    color: rgb(32, 36, 43);
    font-size: var(--font-size-24);
    font-weight: 750;
    letter-spacing: -0.025em;
  }

  p {
    margin: 7px 0 0;
    color: #7b8591;
    font-size: var(--font-size-12);
  }

  @media (max-width: 560px) {
    align-items: flex-start;
    flex-direction: column;
    padding: 18px 20px;
  }
`;

const RequiredGuide = styled.div`
  color: var(--color-text-muted);
  font-size: var(--font-size-11);

  span {
    margin-right: 3px;
    color: var(--color-danger);
    font-weight: 800;
  }
`;

const MediaFormLayout = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1fr) 286px;
  align-items: start;
  gap: 22px;

  @media (max-width: 1180px) {
    grid-template-columns: 1fr;
  }
`;

const MediaFormBoard = styled.section`
  min-width: 0;
  overflow: hidden;
  border: 1px solid #e6e9ed;
  border-radius: 16px;
  background: var(--color-surface);
  box-shadow: 0 10px 30px rgba(31, 41, 55, .07);
`;

const MediaFormSurface = styled.div`
  padding: 24px 26px 10px;
  background: #f5f7f9;

  ${Board} {
    padding: 0;
    overflow: visible;
    margin-bottom: 18px;
    border: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }

  ${BoardHeader} {
    min-height: 44px;
    padding: 0 0 11px;
    background: transparent;
    color: #202a35;
    font-size: var(--font-size-17);
    font-weight: 700;

    &::before {
      display: none;
    }
  }

  ${Board} > ${RowSpan} {
    min-height: 56px;
    padding: 12px 20px;
    border: 0;
    border-right: 1px solid #dfe4e9;
    border-left: 1px solid #dfe4e9;
    background: var(--color-surface);
  }

  ${Board} > ${RowSpan}:nth-child(2) {
    border-top: 1px solid #dfe4e9;
    border-radius: 8px 8px 0 0;
  }

  ${Board} > ${RowSpan}:last-child {
    border-bottom: 1px solid #dfe4e9;
    border-radius: 0 0 8px 8px;
  }

  ${Board} > ${RowSpan}:nth-child(2):last-child {
    border-radius: 8px;
  }

  @media (max-width: 720px) {
    padding: 16px 12px 2px;
  }
`;

const MediaFormSidebar = styled.aside`
  position: sticky;
  top: 18px;
  overflow: hidden;
  border: 1px solid #e6e9ed;
  border-radius: 16px;
  background: var(--color-surface);
  box-shadow: 0 10px 30px rgba(31, 41, 55, .08);

  ${SubmitContainer} {
    position: static;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    margin: 0;
    padding: 14px;
    border: 0;
    border-top: 1px solid #e6e9ed;
    border-radius: 0;
    box-shadow: none;
    backdrop-filter: none;

    button {
      width: 100%;
      min-width: 0;
      margin: 0;
    }
  }

  @media (max-width: 1180px) {
    position: static;
  }
`;

const SidebarTitle = styled.div`
  padding: 20px 20px 6px;
  color: #29323d;
  font-size: var(--font-size-16);
  font-weight: 800;
`;

const SidebarGuide = styled.div`
  padding: 0 20px 16px;
  border-bottom: 1px solid var(--color-divider);
  color: var(--color-text-muted);
  font-size: var(--font-size-12);
`;

const SetupStepList = styled.ol`
  display: flex;
  margin: 0;
  padding: 14px 18px;
  flex-direction: column;
  gap: 4px;
  list-style: none;
`;

const SetupStep = styled.button`
  display: flex;
  width: 100%;
  min-height: 42px;
  align-items: center;
  gap: 10px;
  padding: 0 8px;
  border: 0;
  border-radius: 7px;
  background: ${({$completed}) => ($completed ? "#f0fdfa" : "transparent")};
  color: ${({$completed}) => ($completed ? "#0f766e" : "#5f6975")};
  font-size: var(--font-size-13);
  text-align: left;
  cursor: pointer;
  transition: background .15s ease, color .15s ease;

  &:first-child:not(:hover) {
    background: ${({$completed}) => ($completed ? "#f0fdfa" : "var(--color-primary-soft)")};
    color: ${({$completed}) => ($completed ? "#0f766e" : "var(--color-primary-dark)")};
    font-weight: 700;
  }

  &:hover {
    background: var(--color-primary-soft);
    color: var(--color-primary-dark);
  }

  &:focus-visible {
    outline: 2px solid var(--color-primary-focus);
    outline-offset: 1px;
  }

  b {
    display: inline-flex;
    width: 24px;
    height: 24px;
    flex: 0 0 24px;
    align-items: center;
    justify-content: center;
    border: 1px solid ${({$completed}) => ($completed ? "#99f6e4" : "var(--color-primary-border)")};
    border-radius: 50%;
    background: ${({$completed}) => ($completed ? "#14b8a6" : "var(--color-surface)")};
    color: ${({$completed}) => ($completed ? "var(--color-surface)" : "var(--color-primary)")};
    font-size: var(--font-size-11);
  }
`;

const CompleteLabel = styled.em`
  display: inline-flex;
  height: 20px;
  flex: 0 0 auto;
  align-items: center;
  margin-left: auto;
  padding: 0 7px;
  border: 1px solid #99f6e4;
  border-radius: 999px;
  background: var(--color-surface);
  color: #0f766e;
  font-size: var(--font-size-10);
  font-style: normal;
  font-weight: 750;
  white-space: nowrap;
`;
